import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const StopSign24 = (props: SvgIconProps): JSX.Element => React.createElement(SvgIcon, props, <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='M7.094 18.32A8 8 0 0 0 18.32 7.094L7.094 18.32ZM5.68 16.906 16.906 5.68A8 8 0 0 0 5.68 16.906ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Z' /></svg>);
